import { createFileRoute } from '@tanstack/react-router';
import { choicesReadGuard } from '@bmwe/ui';
import { ChoiceTypeManagement } from '../../../features/choices/choiceTypeManagement';

export const Route = createFileRoute('/auswahlfelder/transportmittel/')({
  component: () => (
    <ChoiceTypeManagement
      choiceTypeKey="DossierTransportationConveyances"
      returnRoute="/auswahlfelder/dossierTransportationConveyances"
    />
  ),
  beforeLoad: choicesReadGuard,
});

export const DossierTransportationConveyancesRoute = Route;
